import { render, staticRenderFns } from "./VerifyIdentitySuccess.vue?vue&type=template&id=087bd33a"
import script from "./VerifyIdentitySuccess.vue?vue&type=script&lang=js"
export * from "./VerifyIdentitySuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports